import { fork, all } from "redux-saga/effects";
import usersSagaGetUser from "./reducers/users/users.saga.getUsers";
import usersSagaCreateUser from "./reducers/users/users.saga.createUser";
import usersSagaSelectUser from "./reducers/users/users.saga.selectUser";
import usersSagaUpdateUser from "./reducers/users/users.saga.updateUser";
import authorizationSagaAuthenticate from "./reducers/authorization/authorization.saga.authenticate";
import inventoriesSagaGetInventory from "./reducers/inventories/inventories.saga.getInventories";
import inventoriesSagaCreateInventory from "./reducers/inventories/inventories.saga.createInventory";
import inventoriesSagaSelectInventory from "./reducers/inventories/inventories.saga.selectInventory";
import inventoriesSagaUpdateInventory from "./reducers/inventories/inventories.saga.updateInventory";
import roomsSagaGetRoom from "./reducers/rooms/rooms.saga.getRooms";
import roomsSagaCreateRoom from "./reducers/rooms/rooms.saga.createRoom";
import roomsSagaSelectRoom from "./reducers/rooms/rooms.saga.selectRoom";
import roomsSagaUpdateRoom from "./reducers/rooms/rooms.saga.updateRoom";
import rolesSagaGetRole from "./reducers/roles/roles.saga.getRoles";
import rolesSagaCreateRole from "./reducers/roles/roles.saga.createRole";
import rolesSagaSelectRole from "./reducers/roles/roles.saga.selectRole";
import rolesSagaUpdateRole from "./reducers/roles/roles.saga.updateRole";
import authorizationSagaGetUser from "./reducers/authorization/authorization.saga.getUser";
import bookingSaga from "./reducers/bookings/sagas";


export function* rootSaga() {
  yield all([
    ...bookingSaga,
    fork(rolesSagaGetRole),
    fork(rolesSagaCreateRole),
    fork(rolesSagaSelectRole),
    fork(rolesSagaUpdateRole),
    fork(usersSagaGetUser),
    fork(usersSagaCreateUser),
    fork(usersSagaSelectUser),
    fork(usersSagaUpdateUser),
    fork(inventoriesSagaGetInventory),
    fork(inventoriesSagaCreateInventory),
    fork(inventoriesSagaSelectInventory),
    fork(inventoriesSagaUpdateInventory),
    fork(roomsSagaGetRoom),
    fork(roomsSagaCreateRoom),
    fork(roomsSagaSelectRoom),
    fork(roomsSagaUpdateRoom),
    fork(authorizationSagaAuthenticate),
    fork(authorizationSagaGetUser)
  ]);
}
